import {
  Button,
  Divider,
  Drawer,
  Form,
  Input,
  InputRef,
  Select,
  Space,
  Tooltip,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { IBaseDrawerModel } from "../../../Types";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/Routing/PageRoute";
import OrganisationsService, {
  IDepartmentOptionsList,
  IDesignationOptionsList,
  IEmpRequestModel,
  ISubUnitOptionsList,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";
import { DrawerProps } from "antd/lib";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useHotkey } from "../../Context/HotKeyContext";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import AddOrganisationModel from "./AddOrganisationModel";
import AddSubUnitModel from "./AddSubUnitModel";
import AddDepttModel from "./AddDepttModel";
import AddDesignationModel from "./AddDesignationModel";
interface IEmpModelProps extends IBaseDrawerModel {
  setAddedEmployee?: React.Dispatch<React.SetStateAction<IIdNameModel>>;
  placement?: DrawerProps["placement"];
}
const AddEmpModel = ({
  isModalOpen,
  setIsModalOpen,
  id,
  setTrigger,
  setAddedEmployee,
  placement = "right",
}: IEmpModelProps) => {
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [orgList, setOrgList] = useState<IIdNameModel[]>([]);
  const [subUnitList, setSubUnitList] = useState<ISubUnitOptionsList[]>([]);
  const [depttList, setDepttList] = useState<IDepartmentOptionsList[]>([]);
  const [designationList, setDesignationList] = useState<
    IDesignationOptionsList[]
  >([]);
  const [allEmployeesData, setAllEmployeesData] = useState<string[]>([]);
  const [duplicateData, setDuplicateData] = useState<boolean>(false);
  const [selOrg, setSelOrg] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [selSubUnit, setSelSubUnit] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [selDeptt, setSelDeptt] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const autoCompleteRef = useRef<InputRef>(null);
  const [newOrganisationResponse, setNewOrganisationResponse] =
    useState<IIdNameModel>({ id: "", name: "" });
  const [addOpenModel, setAddOpenModel] = useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  const [newSubUnitResponse, setNewSubUnitResponse] =
    useState<ISubUnitOptionsList>({ id: "", name: "", orgId: "" });
  const [newDepartmentResponse, setNewDepartmentResponse] =
    useState<IDepartmentOptionsList>({ id: "", name: "", subUnitId: "" });
  const [newDesignationResponse, setNewDesignationResponse] =
    useState<IDesignationOptionsList>({ id: "", name: "", depttId: "" });

  //-----Add New Organization Data -----------//
  useEffect(() => {
    if (newOrganisationResponse.id.length > 0) {
      setOrgList((pre: IIdNameModel[]) => {
        let newData = [...pre, newOrganisationResponse];
        return newData;
      });
    }
  }, [newOrganisationResponse]);

  //----- newly added organisation data placed in form ----------//
  useEffect(() => {
    let exist = orgList.some(
      (e: IIdNameModel) => e.id === newOrganisationResponse.id
    );
    if (exist) {
      form.setFieldValue("orgId", {
        key: newOrganisationResponse.id,
        value: newOrganisationResponse.id,
        label: newOrganisationResponse.name,
        title: "",
      });
      setSelOrg({
        id: newOrganisationResponse?.id,
        name: newOrganisationResponse.name,
      });
      form.setFieldValue("subUnitId", undefined);
      setSelSubUnit({ id: "", name: "" });
    }
  }, [orgList]);

  useEffect(() => {
    if (newSubUnitResponse.id.length > 0) {
      setSubUnitList((pre: ISubUnitOptionsList[]) => {
        let newData = [...pre, newSubUnitResponse];
        return newData;
      });
    }
  }, [newSubUnitResponse]);

  //----- newly added sub unit data data placing in form ----------//
  useEffect(() => {
    console.log("newSubUnitResponse", newSubUnitResponse);
    let exist = subUnitList.some(
      (e: ISubUnitOptionsList) => e.id === newSubUnitResponse.id
    );
    if (exist) {
      form.setFieldValue("subUnitId", {
        key: newSubUnitResponse.id,
        value: newSubUnitResponse.id,
        label: newSubUnitResponse.name,
        title: "",
      });
      setSelSubUnit({
        id: newSubUnitResponse.id,
        name: newSubUnitResponse.name,
      });
      form.setFieldValue("depttId", undefined);
      setSelDeptt({id:"",name:""})
    }
  }, [subUnitList]);

  //----- adding new  Department data  ----------//
  useEffect(() => {
    if (newDepartmentResponse?.id.length > 0) {
      setDepttList((pre: IDepartmentOptionsList[]) => {
        let newData = [...pre, newDepartmentResponse];
        return newData;
      });
    }
  }, [newDepartmentResponse]);

  //----- newly added Department data  placing in form ----------//
  useEffect(() => {
    let exist = depttList.some(
      (e: IDepartmentOptionsList) => e.id === newDepartmentResponse.id
    );
    if (exist) {
      form.setFieldValue("depttId", {
        key: newDepartmentResponse.id,
        value: newDepartmentResponse.id,
        label: newDepartmentResponse.name,
        title: "",
      });
      setSelDeptt({
        id: newDepartmentResponse.id,
        name: newDepartmentResponse.name,
      });
    }
  }, [depttList]);

  //----- adding new  Department data  ----------//
  useEffect(() => {
    if (newDepartmentResponse?.id.length > 0) {
      setDepttList((pre: IDepartmentOptionsList[]) => {
        let newData = [...pre, newDepartmentResponse];
        return newData;
      });
    }
  }, [newDepartmentResponse]);

  //----- newly added Department data  placing in form ----------//
  useEffect(() => {
    let exist = depttList.some(
      (e: IDepartmentOptionsList) => e.id === newDepartmentResponse.id
    );
    if (exist)
      form.setFieldValue("depttId", {
        key: newDepartmentResponse.id,
        value: newDepartmentResponse.id,
        label: newDepartmentResponse.name,
        title: "",
      });
  }, [depttList]);

  //----- adding new  Designation data  ----------//
  useEffect(() => {
    if (newDesignationResponse?.id.length > 0) {
      setDesignationList((pre: IDesignationOptionsList[]) => {
        let newData = [...pre, newDesignationResponse];
        return newData;
      });
    }
  }, [newDesignationResponse]);

  //----- newly added Designation data  placing in form ----------//
  useEffect(() => {
    let exist = designationList.some(
      (e: IDesignationOptionsList) => e.id === newDesignationResponse.id
    );
    if (exist)
      form.setFieldValue("designationId", {
        key: newDesignationResponse.id,
        value: newDesignationResponse.id,
        label: newDesignationResponse.name,
        title: "",
      });
  }, [designationList]);

  const saveData = () => {
    setLoading(true);
    form.validateFields().then(async (val) => {
      let newVal = {
        ...val,
        empName: val.empName.trim(),
        orgId: val.orgId?.value,
        subUnitId: val.subUnitId?.value,
        depttId: val.depttId?.value,
        designationId: val.designationId?.value,
      };

      await OrganisationsService.postEmployee(currentClient?.id!, newVal, id!)
        .then((val: IApiResponse<IIdNameModel>) => {
          if (val.result) {
            console.log(val.result);
            setAddedEmployee && setAddedEmployee(val?.result);
            openNotification(
              "success",
              `${val?.result?.name} employee ${
                id ? "updated" : "added"
              } successfully`
            );
            setIsModalOpen({
              open: false,
              id: "",
            });
            setLoading(false);
            setTrigger && setTrigger((prev) => !prev);
          } else {
            setLoading(false);
            openNotification("error", val.message);
          }
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    });
  };

  const getData = async () => {
    setLoading(true);
    await OrganisationsService.getEmployee(currentClient?.id!, id!)
      .then((val: IEmpRequestModel | null) => {
        setSelOrg({ id: val?.orgId!, name: "" });
        setSelSubUnit({ id: val?.subUnitId!, name: "" });
        setSelDeptt({ id: val?.depttId!, name: "" });
        let formValues: IEmpRequestModel = {
          empName: val?.empName as string,
          empCode: val?.empCode as string,
          fatherName: val?.fatherName as string,
          email: val?.email as string,
          createLoginCredential: val?.createLoginCredential as boolean,
          seniorEmpId: val?.seniorEmpId as string,
          orgId: val?.orgId as string,
          subUnitId: val?.subUnitId as string,
          depttId: val?.depttId as string,
          designationId: val?.designationId as string,
        };
        form.setFieldsValue(formValues);
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };                           
  useEffect(() => {
    if (id) getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getOrgList = async () => {
    setLoading(true);
    await OrganisationsService.getOrgOptionsList(currentClient?.id!)
      .then((val) => {
        if (val) {
          setOrgList(val);
        }
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  const handleDuplicates = (subUnitName: string) => {
    let filteredData = allEmployeesData.filter(
      (e) => e.toLowerCase().trim() === subUnitName.toLowerCase().trim()
    );
    if (filteredData.length > 0) setDuplicateData(true);
    else setDuplicateData(false);
  };
  const getSubUnitList = async () => {
    setLoading(true);
    await OrganisationsService.getSubUnitOptionsList(currentClient?.id!)
      .then((val) => {
        if (val) {
          setSubUnitList(val);
        }
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  const getDepttList = async () => {
    setLoading(true);
    await OrganisationsService.getDepartmentOptionsList(currentClient?.id!)
      .then((val: IDepartmentOptionsList[] | null) => {
        if (val) {
          setDepttList(val);
        }
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    (async () => {
      await OrganisationsService.getEmployeesOptionsList(
        currentClient?.id!
      ).then((data: IIdNameModel[] | null) => {
        setAllEmployeesData(data!.map((each: IIdNameModel) => each.name));
      });
    })();
  }, []);
  const getDesignationList = async () => {
    setLoading(true);
    await OrganisationsService.getDesignationOptionsList(currentClient?.id!)
      .then((val: IDesignationOptionsList[] | null) => {
        if (val) {
          setDesignationList(val);
        }
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };
  useEffect(() => {
    getOrgList();
    getSubUnitList();
    getDepttList();
    getDesignationList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);
  useEffect(() => {
    if (orgList.length > 0) {
      const timer = setTimeout(() => {
        if (autoCompleteRef.current) {
          autoCompleteRef.current.focus();
        }
      }, 100); // Adjust delay if needed

      return () => clearTimeout(timer);
    }
  }, [orgList]); // Ensures autofocus after initial render

  EntryLevelKeys({
    save: () => saveData(),
    cancel: () =>
      setIsModalOpen({
        open: false,
        id: "",
      }),
  });

  return (
    <>
      <Drawer
        open={isModalOpen}
        onClose={() =>
          setIsModalOpen({
            open: false,
            id: "",
          })
        }
        maskClosable={false}
        closable={false}
        extra={
          <Space>
            <CloseOutlined
              onClick={() =>
                setIsModalOpen({
                  open: false,
                  id: "",
                })
              }
            />
          </Space>
        }
        placement={placement}
        title={`${id ? "Update" : "Add"} employee`}
        width={"500px"}
        footer={
          <div style={{ textAlign: "right" }}>
            <Space>
              <Tooltip
                title={<p>ALT+C</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  disabled={loading}
                  onClick={() => {
                    form.resetFields();
                    setIsModalOpen({
                      open: false,
                      id: "",
                    });
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>

              <Tooltip
                title={<p>ALT+S</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  disabled={loading}
                  loading={loading}
                  type="primary"
                  onClick={() => saveData()}
                >
                  {`${id ? "Update" : "Save"}`}
                </Button>
              </Tooltip>
            </Space>
          </div>
        }
      >
        <Form name="employee" form={form} disabled={loading} layout="vertical">
          <Form.Item
            name="empName"
            label="Employee's Name"
            rules={[
              { required: true },
              {
                pattern:
                  /^(?!.* {2})([A-Za-z][A-Za-z0-9_()&\-., ]{1,48}[A-Za-z0-9])$/,
                message: "Value's length must be between 3 and 50",
              },
              {
                validator: () => {
                  if (duplicateData)
                    return Promise.reject("Employee Name already exist");
                  else return Promise.resolve();
                },
              },
            ]}
            className="input-item"
          >
            <Input
              type="text"
              maxLength={50}
              minLength={3}
              placeholder="Enter name here..."
              onChange={(e) => handleDuplicates(e.target.value)}
              ref={autoCompleteRef}
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="Employee's Email"
            rules={[
              { required: true },
              {
                type: "email",
                message: "Please enter a valid email",
              },
            ]}
            className="input-item"
          >
            <Input type="email" placeholder="Enter email here..." />
          </Form.Item>

          <Form.Item
            name="fatherName"
            label="Employee's Father's Name"
            rules={[
              { required: true },
              {
                pattern:
                  /^(?!.* {2})([A-Za-z][A-Za-z0-9_()&\-., ]{1,48}[A-Za-z0-9])$/,
                message: "Value's length must be between 3 and 50",
              },
            ]}
            className="input-item"
          >
            <Input
              type="text"
              maxLength={50}
              minLength={3}
              placeholder="Enter name here..."
            />
          </Form.Item>

          <Form.Item
            name="empCode"
            label="Employee's Code"
            rules={[
              { required: true },
              {
                pattern:
                  /^(?!.* {2})([A-Za-z][A-Za-z0-9_()&\-., ]{1,18}[A-Za-z0-9])$/,
                message: "Value's length must be between 2 and 20",
              },
            ]}
            className="input-item"
          >
            <Input
              type="text"
              maxLength={50}
              minLength={3}
              placeholder="Enter code here..."
            />
          </Form.Item>

          <Form.Item
            name="orgId"
            label="Organisation"
            rules={[{ required: true, message: "Please select organisation" }]}
            className="input-item"
          >
            <Select
              labelInValue
              placeholder="Select organisation"
              onChange={(val) => {
                form.setFieldValue("subUnitId", undefined);
                form.setFieldValue("depttId", undefined);
                form.setFieldValue("designationId", undefined);
                setSelOrg({ id: val?.value, name: val?.label });
                setSelSubUnit({ id: "", name: "" });
                setSelDeptt({ id: "", name: "" });
              }}
              options={orgList.map((org: IIdNameModel) => ({
                label: org.name,
                value: org.id,
                key: org.id,
                title: "",
              }))}
              dropdownRender={(orgList) => (
                <>
                  {orgList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "Organisation",
                        param: {},
                      })
                    }
                  >
                    New Organisation
                  </Button>
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            name="subUnitId"
            label="Sub Unit"
            rules={[{ required: true, message: "Please select sub unit" }]}
            className="input-item"
          >
            <Select
              labelInValue
              disabled={selOrg.id === ""}
              placeholder="Select sub unit"
              onChange={(val) => {
                form.setFieldValue("depttId", undefined);
                form.setFieldValue("designationId", undefined);
                setSelSubUnit({ id: val?.value, name: val?.label });
                setSelDeptt({ id: "", name: "" });
              }}
              options={subUnitList
                .filter(
                  (subUnit: ISubUnitOptionsList) => subUnit.orgId === selOrg.id
                )
                .map((subUnit: ISubUnitOptionsList) => ({
                  label: subUnit.name,
                  value: subUnit.id,
                  key: subUnit.id,
                  title: "",
                }))}
              dropdownRender={(subUnitList) => (
                <>
                  {subUnitList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "SubUnit",
                        param: {},
                      })
                    }
                  >
                    New Sub Unit
                  </Button>
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            name="depttId"
            label="Department"
            rules={[{ required: true, message: "Please select department" }]}
            className="input-item"
          >
            <Select
              labelInValue
              disabled={selSubUnit.id === ""}
              placeholder="Select department"
              onChange={(val) => {
                form.setFieldValue("designationId", undefined);
                setSelDeptt({ id: val?.value, name: val?.label });
              }}
              options={depttList
                .filter(
                  (deptt: IDepartmentOptionsList) =>
                    deptt.subUnitId === selSubUnit.id
                )
                .map((deptt: IDepartmentOptionsList) => ({
                  label: deptt.name,
                  value: deptt.id,
                  key: deptt.id,
                  title: "",
                }))}
              dropdownRender={(depttList) => (
                <>
                  {depttList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "New Department",
                        param: {},
                      })
                    }
                  >
                    New Department
                  </Button>
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            name="designationId"
            label="Designation"
            rules={[{ required: true, message: "Please select designation" }]}
            className="input-item"
          >
            <Select
              labelInValue
              disabled={selDeptt.id === ""}
              placeholder="Select designation"
              options={designationList
                .filter(
                  (des: IDesignationOptionsList) => des?.depttId === selDeptt.id
                )
                .map((des: IDesignationOptionsList) => ({
                  label: des.name,
                  value: des.id,
                  key: des.id,
                  title: "",
                }))}
              dropdownRender={(designationList) => (
                <>
                  {designationList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setAddOpenModel({
                        type: "New Designation",
                        param: {},
                      })
                    }
                  >
                    New Designation
                  </Button>
                </>
              )}
            />
          </Form.Item>
          {/* <Form.Item
          name="seniorEmpId"
          label="Senior Employee"
          // rules={[{ required: true, message: "Please select senior employee" }]}
        >
          <Select
            placeholder="Select senior employee"
            options={designationList
              .filter((des: IDesignationData) => des.depttId === selDeptt)
              .map((des: IDesignationData) => ({
                label: des.designationName,
                value: des.id,
                key: des.id,
                title: "",
              }))}
          />
        </Form.Item> */}
        </Form>
      </Drawer>
      {addOpenModel.type === "Organisation" && (
        <AddOrganisationModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewResponse={setNewOrganisationResponse}
          placement={"left"}
        />
      )}
      {addOpenModel.type === "SubUnit" && (
        <AddSubUnitModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewSubUnitResponse={setNewSubUnitResponse}
          placement={"left"}
          organisationId={selOrg.id}
          organisationName={selOrg.name}
        />
      )}
      {addOpenModel.type === "New Department" && (
        <AddDepttModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewDepartmentResponse={setNewDepartmentResponse}
          placement={"left"}
          organisationId={selOrg.id}
          organisationName={selOrg.name}
          subUnitId={selSubUnit.id}
          subUnitName={selSubUnit.name}
        />
      )}
      {addOpenModel.type === "New Designation" && (
        <AddDesignationModel
          isModalOpen={true}
          setOpenModel={setAddOpenModel}
          setNewDesignationResponse={setNewDesignationResponse}
          placement={"left"}
          organisationId={selOrg.id}
          organisationName={selOrg.name}
          subUnitId={selSubUnit.id}
          subUnitName={selSubUnit.name}
          departmentId={selDeptt.id}
          departmentName={selDeptt.name}
        />
      )}
    </>
  );
};

export default AddEmpModel;
